import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  getMatchByUserId,
  type GetMatchByUserIdParams,
  type GetMatchByUserIdResponse,
} from '@services/MatchesService';

export type UseGetMatchByUserIdParams = {
  mutationOptions?: SWRMutationConfiguration<
    GetMatchByUserIdResponse,
    unknown,
    string,
    GetMatchByUserIdParams,
    GetMatchByUserIdResponse
  >;
};

export const getMatchByUserIdMutationKey = 'get-match-by-user-id';

export const useGetMatchByUserId = ({
  mutationOptions,
}: UseGetMatchByUserIdParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    GetMatchByUserIdResponse,
    unknown,
    string,
    GetMatchByUserIdParams
  >(
    getMatchByUserIdMutationKey,
    (_url, { arg }) => getMatchByUserId(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
